import { api } from './api';

const auditsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAuditDisclosures: builder.query<AuditDisclosure[], void>({
      query: () => 'audits/disclosures',
    }),
  }),
});

// A disclosure this identity holds a direct grant on. Enough to list and link
// to it; the disclosure itself is read in suit.
export type AuditDisclosure = {
  id: number;
  name: string;
  draft: boolean;
  updatedAt: string;
};

// Where a shared disclosure is read. Suit serves this, behind the `/audits`
// prefix it claims from zoo at the CDN.
export const auditDisclosurePathname = (id: number) =>
  `/audits/disclosures/${id}`;

export const { useGetAuditDisclosuresQuery } = auditsApi;

export { auditsApi };
